import Providers from "./contexts/Providers";
import AuthLayout from "./layout/auth/AuthLayout";
import { Toaster } from "sonner";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import '@fontsource/inter'; // default 400
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
polyfillCountryFlagEmojis();

function App() {
  return (
    <Providers>
      <Toaster position="top-center"/>
      <AuthLayout />      
    </Providers>
  );
}

export default App;
